import { useAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import useTenant from "src/hooks/api/services/tenants/useTenant";

export type TaskView = "kanban" | "list";

const tasksViewAtom = atomWithStorage<TaskView>("tasks-view", "kanban");

export default function useTasksView() {
	const [view, setView] = useAtom(tasksViewAtom);
	const { tenant } = useTenant();

	return {
		view: tenant.modules.includes("intern-task") ? view : "list",
		setView,
	};
}
